export default function IconAttachment({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g id="Attachment-1 Streamline Ultimate">
        <path
          id="Vector"
          d="M1.5 9.00073C1.5 10.9899 2.29018 12.8975 3.6967 14.304C5.10322 15.7106 7.01088 16.5007 9 16.5007C10.9891 16.5007 12.8968 15.7106 14.3033 14.304C15.7098 12.8975 16.5 10.9899 16.5 9.00073C16.5 7.01161 15.7098 5.10395 14.3033 3.69743C12.8968 2.29091 10.9891 1.50073 9 1.50073C7.01088 1.50073 5.10322 2.29091 3.6967 3.69743C2.29018 5.10395 1.5 7.01161 1.5 9.00073Z"
          fill="#93C5FD"
        />
        <path
          id="Vector_2"
          d="M7.125 12.75V7.125C7.125 5.883 7.75725 4.875 9 4.875C10.2427 4.875 10.875 5.883 10.875 7.125V14.25C10.875 16.1145 9.73875 17.625 7.875 17.625C6.01125 17.625 4.875 16.1145 4.875 14.25V4.875C4.875 2.3895 6.51525 0.375 9 0.375C11.4847 0.375 13.125 2.3895 13.125 4.875V11.625"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
